export enum CaseSizeRuleCreateDialogPage {
  CREATE_PACKAGE_RULE,
  UPDATE_MOQ_RULES,
  VOLUME_DISCOUNT_RULES,
}
